module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO8Decisiones (ant39).6890cc3.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO8Decisiones (ant39).mp4
// module id = 814
// module chunks = 1